import { API_V2 } from "@/config/api";

const base = `${API_V2}/chat`;

export const chatRoutes = {
  list: base,
  get: (conversationId: string) => `${base}/${conversationId}`,
  update: (conversationId: string) => `${base}/${conversationId}`,
  archive: (conversationId: string) => `${base}/${conversationId}/archive`,
};
